import { render } from "./ArrowBtn.vue?vue&type=template&id=4b6df38c&scoped=true"
import script from "./ArrowBtn.vue?vue&type=script&lang=js"
export * from "./ArrowBtn.vue?vue&type=script&lang=js"

import "./ArrowBtn.vue?vue&type=style&index=0&id=4b6df38c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6df38c"]])

export default __exports__